import React, {useEffect} from 'react';
import {CarouselLabs} from '../../../ui';
import {useDocumentTitle} from '../../../components/Theme/useDocumentTitle';
import {toast} from 'react-toastify';
import {FeaturedProducts} from './FeaturedProducts';
import {BannerSlider} from './BannerSlider';
import {Catalogs} from './Catalogs';
import {BannersContextProvider} from '../infrastructure/BannersContext';
import {FavoriteProducts} from './FavoriteProducts';
import {TrackedProductsSwiper} from "./TrackedProductsSwiper";
import {RestockedTrackedProducts} from "./RestockedTrackedProducts";
import {CombinabledProductsSwiper} from "./CombinabledProductsSwiper";
import {LotPromotionProductsSwiper} from "./LotPromotionProductsSwiper";
import {useFilterContext} from "../../catalog/infrastructure/FilterContext";


function Home() {
  useDocumentTitle('Inicio');
  const { clearFilters } = useFilterContext();
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    const message = localStorage.getItem('message');
    if (isLoggedIn) {
      toast.success(message, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2500
      });
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('message');
    }
    clearFilters();
  }, [clearFilters]);
  return (
    <BannersContextProvider>
      <section className="container justify-content-center">
        <div style={{ marginTop: '20px' }}>
          <BannerSlider />
        </div>
          <div style={{ marginTop: '2rem' }}>
              <Catalogs />
          </div>
        <div style={{ marginTop: '2rem' }}>
          <RestockedTrackedProducts />
        </div>
        <div style={{ marginTop: '2rem' }}>
          <TrackedProductsSwiper />
        </div>
        <div style={{ marginTop: '2rem' }}>
          <FavoriteProducts />
        </div>
        <div style={{ marginTop: '2rem' }}>
          <FeaturedProducts />
        </div>
        <div style={{ marginTop: '2rem' }}>
          <CombinabledProductsSwiper />
        </div>
        <div style={{ marginTop: '2rem' }}>
          <LotPromotionProductsSwiper />
        </div>
        <div style={{ marginTop: '2rem' }}>
          <CarouselLabs />
        </div>
      </section>
    </BannersContextProvider>
  );
}

export {
  Home
};